import { InjectionToken } from '@angular/core';

/**
 * @description
 * Provide max image number and max document number to Asset and Ticket
 *
 */
export const AssetAttachmentLimitsToken = new InjectionToken<{
  imgMaxNumber: number;
  docMaxNumber: number;
  videoMaxNumber: number;
}>('Attachment limits configuration');
